import { render, staticRenderFns } from "./EditCollege.vue?vue&type=template&id=dcb8ee5c&scoped=true"
import script from "./EditCollege.vue?vue&type=script&lang=js"
export * from "./EditCollege.vue?vue&type=script&lang=js"
import style0 from "./EditCollege.vue?vue&type=style&index=0&id=dcb8ee5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb8ee5c",
  null
  
)

export default component.exports